// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"265":"Index","612":"CreateProductData","775":"ContentCreateSite","863":"AIProductManage","883":"LoginPage"}[chunkId] || chunkId) + "." + {"265":"53aaa","410":"627c6","520":"daec7","612":"67f9e","775":"ddb7b","863":"bde51","883":"4972c"}[chunkId] + ".css";
};